export default __webpack_public_path__ + "static/media/phd.1fc2de28.svg";